<template>
  <div class="task-priority-release" v-loading="loading">
    <div class="top">
      <ul class="task-priority-item-wrap">
        <li
          class="task-priority-item"
          v-for="item in sortRuleOverviewData"
          :key="item.sort_rule_id"
          :class="getPriorityClass(item)"
          @click="handleChos(item)"
        >
          <p class="percents">{{ item.poin }}%</p>
          <p class="priority-level">{{ item.sort_rule.sort_name }}</p>
          <el-progress
            :percentage="item.poin"
            :show-text="false"
          ></el-progress>
        </li>
      </ul>
    </div>

    <Statistics-table
      ref="table"
      :height="height"
      :tableList="tableList"
      :finishLoad="finishLoad"
      :filterOptions="filterOptions"
      :isScrollLoading="isScrollLoading"
      :tableHeadList="tableFilterFields"
      @load="load"
      @tableSortChange="tableSortChange"
    ></Statistics-table>

    <nothing v-if="!tableList.length"></nothing>

  </div>
</template>

<script>
import api from '@/services/api/statistics/statistics'
import customKeyApi from '@/services/api/customKey/customKey'
import { fixedFieldSettings } from '@/const/statistics.js'

import StatisticsTable from './table.vue'

export default {
  components: {
    StatisticsTable
  },
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    // 任务优先级
    sortRuleId: {
      type: Number,
      default: 0
    },
    // 筛选项
    filterOptions: {
      type: Object,
      default() {
        return {
          task_level: 0, // 任务层级筛选
          task_list_ids: [], // 任务清单筛选
          executors_uid: [], // 执行人筛选
          task_members_uid: [], // 参与人筛选
          sort_switch: 0, // 排序开关 是否开启自定义排序
          sorting_rules: [], // 自定义排序规则
          field_display_settings: [], // 字段设置
        }
      }
    }
  },
  computed: {
    // 表格筛选字段列表
    tableFilterFields() {
      let _arr = JSON.parse(JSON.stringify(this.filterOptions.field_display_settings))
      if (this.filterOptions.sort_switch && this.filterOptions.sorting_rules.length) {
        // 排序开关开着的情况下
        _arr.forEach(item => {
          const _item = JSON.parse(this.filterOptions.sorting_rules).find(obj => obj.hasOwnProperty(item.field_name))
          if (_item) {
            item.sort = _item[item.field_name]
          }
        })
      }
      return _arr.length ? _arr.filter(item => item.display === true) : []
    }
  },
  data() {
    return {
      isInit: true, // 是否为初始化
      height: null,
      sortRuleOverviewData: [],//优先级分布
      param: {
        per_page: 30,
        page: 1
      },
      fixedFieldSettings,
      isFirst: false, // 是否首次获取字段筛选
      loading: false,
      isScrollLoading: false,
      finishLoad: false,
      tableList: [],
      fieldDisplaySettings: [] // 字段设置列表
    }
  },
  watch: {
    // 监听筛选配置项，获取最新的数据
    filterOptions: {
      deep: true,
      handler(val) {
        if (!this.isInit) {
          // 非初始化时才执行监听方法回调
          this.loading = true
          this.finishLoad = false
          this.param.page = 1
          this.tableList = []
          this.init()
          this.getTaskSortRuleTable()
        }
      }
    },
    // 监听任务优先级
    sortRuleId() {
      if (!this.isInit) {
        // 非初始化时才执行监听方法回调
        this.loading = true
        this.finishLoad = false
        this.param.page = 1
        this.tableList = []
        this.getTaskSortRuleTable()
      }
    }
  },
  created() {
    this.loading = true
    this.init() // 初始化获取任务优先级分布
    this.getFilter() // 初始化先获取筛选条件
  },
  mounted() {
    // 获取当前窗口下表格可移动的最高高度 (用窗口的高度减去其他各个元素的高度)
    this.height = window.innerHeight - 78 - 160 - 10
  },
  methods: {
    async init() {
      const { task_level, task_list_ids, executors_uid, task_members_uid } = this.filterOptions
      const param = {
        project_id: this.projectId,
        task_level,
        task_list_ids,
        executors_uid,
        task_members_uid
      }
      const res = await api.sortRuleOverview(param)
      if (res) {
        this.sortRuleOverviewData = res
        this.getRuleAllCount()
      }
    },
    getRuleAllCount() {
      let allCount = this.sortRuleOverviewData.reduce((result, pre) => {
        return result + pre.count * 1
      }, 0)
      this.sortRuleOverviewData.map((res, index) => {
        if (index === 3) {
          let p = 100 - this.sortRuleOverviewData.reduce((result, pre) => {
            return result + (pre.poin ? pre.poin * 1 : 0)
          }, 0)
          res.poin = p
        } else {
          let p = Math.floor((res.count / allCount) * 100)
          res.poin = p
        }
        if (res.sort_rule_id === this.sortRuleId) {
          res.active = true
        } else {
          res.active = false
        }
      })
    },
    getPriorityClass(item) {
      let className = ''
      switch (item.sort_rule.sort_name) {
        case '最高':
          className = 'highest'
          break
        case '中等':
          className = 'medium'
          break
        case '普通':
          className = 'normal'
          break
        case '低':
          className = 'low'
          break
      }
      return `${ className } ${ item.active ? 'active' : '' }`
    },
    // 表格排序改变
    tableSortChange(name, val) {
      const _sortingRules = JSON.parse(this.filterOptions.sorting_rules)
      const _item = _sortingRules.find(obj => obj.hasOwnProperty(name))
      _item[name] = val
      this.$emit('sortSettingsChange', { sorting_rules: _sortingRules, sort_switch: 1 })
    },
    // 获取字段设置
    async getFilter() {
      const _param = {
        project_id: this.projectId,
        statistic_type: 2
      }
      const res = await api.getTableFilter(_param)
      if (res) {
        // if (res.field_display_settings === null || res.field_display_settings.length === 0) {
        //   this.isFirst = true
        // }
        if (res.field_display_settings && res.field_display_settings.length) {
          this.fieldDisplaySettings = JSON.parse(JSON.stringify(res.field_display_settings))

          this.fieldDisplaySettings.forEach(item => {
            item.display = item.display === 'true'
          })
        } else {
          // 初次加载并且首次加载，需添加固定字段设置筛选条件
          this.isFirst = true
          const customFields = await this.getCustomKey() // 获取项目自定义字段
          this.fieldDisplaySettings = [...this.fixedFieldSettings, ...customFields]
        }
        this.$emit('fieldSettingsChange', this.fieldDisplaySettings)
        this.$emit('sortSettingsChange', { sorting_rules: res.sorting_rules, sort_switch: res.sort_switch })

        // 初始化获取任务优先级分布表
        this.getTaskSortRuleTable(true)
      }
    },
    getTaskSortRuleTable(isInit) {
      setTimeout(async () => {
        const _param = Object.assign(this.param, this.filterOptions)
        if (isInit) {
          // 初始化，字段设置初始化
          _param.field_display_settings = this.fieldDisplaySettings
          this.isInit = false
        }
        _param.sort_rule_id = this.sortRuleId
        const res = await api.getTaskSortRuleOverviewTable(_param)
        if (res) {
          this.loading = false
          this.isScrollLoading = false
          this.tableList.push(...res.data)
          if (res.data.length < this.param.per_page) {
            this.finishLoad = true
          }
        }
      }, 500)

    },
    async getCustomKey() {
      let arr = []
      const _param = {
        number: 999,
        page: 1,
        project_id: this.projectId
      }
      const res = await customKeyApi.getprojectTemplate(_param)
      if (res) {
        const _list = res.data[0].template_standard_components
        const _excludedCustomFields = ['TaskComponent.Text.LongText', 'TaskComponent.Text.RichText', 'TaskComponent.Attachment.Attachment']

        // 获取不需要显示之外的自定义字段列表
        const _templateList = _list.filter(item => {
          return !_excludedCustomFields.includes(item.component_code)
        })
        _templateList.forEach(item => {
          arr.push({
            field_type: 'custom',
            field_name: item.component_name_in_template,
            field_name_en: String(item.id),
            field_component_code: item.component_code,
            display: false
          })
        })
      }
      return arr
    },
    load() {
      if (this.finishLoad) return

      this.param.page += 1
      this.isScrollLoading = true
      this.getTaskSortRuleTable()
    },
    handleChos(item) {
      if (item.active) return
      const _list = this.sortRuleOverviewData
      for(let i = 0, len = _list.length; i < len; i++) {
        _list[i].active = false
      }
      item.active = true
      this.$emit('sortRuleChange', item.sort_rule_id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.task-priority-release {
  .top {
    width: 1150px;
    padding: 22px 0 24px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .task-priority-item-wrap {
      width: 100%;
      display: flex;
      justify-content: center;
      li {
        width: 274px;
        height: 114px;
        border-radius: 8px;
        border: 1px solid rgba(32, 32, 32, 0);
        display: flex;
        flex-direction: column;
        margin-right: 18px;
        padding: 14px 0 0 24px;
        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: 1px solid rgba(32, 32, 32, .6);
        }
        &:active {
          border: 1px solid rgba(32, 32, 32, 1);
        }
        &.active {
          border: 1px solid #2682FF;
        }
        .percents {
          font-size: 24px;
          font-weight: bold;
          line-height: 34px;
        }
        .priority-level {
          font-size: 14px;
          line-height: 20px;
          margin: 4px 0 20px;
        }
        .el-progress {
          width: 220px;
          height: 6px;
          /deep/ .el-progress-bar__outer {
            @include bgColorOpacity(.08);
          }
        }
        &.highest {
          .priority-level {
            color: #FF3939;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(255, 57, 57, .8);
          }
        }
        &.medium {
          .priority-level {
            color: #FF8B23;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(255, 121, 17, .8);
          }
        }
        &.normal {
          .priority-level {
            color: #2682FF;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(38, 130, 255, .8);
          }
        }
        &.low {
          .priority-level {
            @include fontColorOpacity(.6);
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(39,39,39,0.41);
          }
        }
      }
    }
  }

  .loading-text {
    text-align: center;
    font-size: 14px;
    line-height: 32px;
    @include fontColorOpacity(.6);
  }
  /deep/ .el-table--border th:first-child .cell,
  /deep/ .el-table--border td:first-child .cell {
    padding-left: 40px;
  }
  /deep/ .el-table__empty-text {
    display: none;
  }
}
</style>
